<app-tabla
  [totalCount]="totalCount"
  [datos]="datos"
  [columnas]="columnas"
  [pageSizeOptions]="helper.pageSizeOptions"
  [search]="search"
  [(query)]="query"
  (queryChange)="listar()"
  [paginatorArriba]="false"
  [crear]="botonCrear"
  [exportar]="botonExportar"
  [filtros]="filtros"
  [name]="name"
  [emptyState]="{ title: 'Todavía no hay clientes' }"
></app-tabla>
